import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=330f2fbe&scoped=true&"
import script from "./Token.vue?vue&type=script&lang=ts&"
export * from "./Token.vue?vue&type=script&lang=ts&"
import style0 from "./Token.vue?vue&type=style&index=0&id=330f2fbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330f2fbe",
  null
  
)

export default component.exports